import React from "react";
import { useNavigate } from "react-router-dom";
//import RevolutPayButton from "./RevolutPayButton";

//import RevolutPayButton from "./RevoultSimplePay";

export default function Dashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <>
    <div className="px-8 py-2 bg-[#E3BCF4] flex justify-between items-center">
      <img src="../logo.png" alt="" className="max-w-[180px] w-full"/>
      <button
        onClick={logout}
        className="bg-[#9B20AC] hover:bg-[#8B1D9A] text-white font-medium py-2 px-6 rounded-lg transition duration-200"
      >
        Logout
      </button>
    </div>
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center flex-col">
      
      <div className="bg-white max-w-[720px] w-full px-6 py-4 rounded-[12px]">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        Welcome {user?.firstname} {user?.lastname}!
      </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8">
        {/* Credit Card Verification */}
        <div className="bg-[#9B20AC] rounded-xl p-4 text-white text-center shadow-lg hover:shadow-xl cursor-pointer transition duration-200">
          <img
              src="/card-verified.jpeg"
              alt="Get Verified using credit card"
              className="mx-auto mb-4 w-64 h-64 object-contain"
          />
          <p className="font-medium">Get Verified using credit card</p>
        </div>

        {/* Photo ID Verification */}
        <div className="bg-[#9B20AC] rounded-xl p-4 text-white text-center shadow-lg hover:shadow-xl cursor-pointer transition duration-200">
          <img
              src="/photo-id-verified.jpeg"
              alt="Get Verified using photo ID"
              className="mx-auto mb-4 w-64 h-64 object-contain"
          />
          <p className="font-medium">Get Verified using photo ID</p>
        </div>
      </div>

    </div>
    </>
  );
}
